import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { IoMdAlert } from "react-icons/io";

import { AuthAction } from "../store/actions";

import { Buttons } from ".";

const GuestUserPopup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    dispatch(AuthAction.Logout());
    navigate("/signup/general-info");
  };

  return (
    <div className="rounded-[1.75em] drop-shadow-md bg-white flex flex-col justify-center items-center gap-1em text-black p-0.3125em">
      <IoMdAlert className="text-[4.125em] text-yellow-400" />
      <div className="text-[1.5em] font-bold text-center">
        Please sign up to view internships
      </div>
      <Buttons.DefaultButton size="medium" onClick={handleButtonClick}>
        Sign Up
      </Buttons.DefaultButton>
    </div>
  );
};

export default GuestUserPopup;
